import { Injectable } from '@angular/core';
import { StatsigService } from '../statsig.service';

export enum FACILITY_MONITORING_FEATURE_FLAGS {
  FE_FACILITY_MONITORING_ENABLED = 'fe-facility-monitoring-enabled',
}

@Injectable({ providedIn: 'root' })
export class FacilityMonitoringFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isFacilityMonitoringFeatureEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FACILITY_MONITORING_FEATURE_FLAGS.FE_FACILITY_MONITORING_ENABLED);
  }
}
